import { render, staticRenderFns } from "./disabledUserButton.vue?vue&type=template&id=30bcdc56&"
import script from "./disabledUserButton.vue?vue&type=script&lang=js&"
export * from "./disabledUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports